import {
  CheckboxFilterOption,
  FilterCategory,
} from "../components/filters/types"

export const mergeFilter = (
  filters: FilterCategory[],
  filter: FilterCategory
) => {
  const filterIndex = filters.findIndex((x) => x.id === filter.id)
  filters[filterIndex] = filter
  return filters
}

export const isBooleanFilterCategory = (category: FilterCategory) => {
  if (category.type === "range") {
    return false
  }

  return (
    category.options
      .map((x: any) => x as CheckboxFilterOption)
      .find((x) => x.code === "true" || x.code === "false") !== undefined
  )
}

// export const filterActiveOptions = (category: FilterCategory) => {
//   return {
//     ...category,
//     options: category.options
//       .map((x: any) => x as CheckboxFilterOption)
//       .filter((x) => x.occurrences > 0),
//   }
// }
